import { backUrl } from "../../utils/backURL";
import { fetchWrapper } from "../../utils/fetchWrapper";
import { withAuthCredentials } from "../../utils/authFetchOptions";

/**
 * Roldan API Calls
 * All functions receive mantisBusinessId and token for authentication
 */

/**
 * ==================== REMESAS ====================
 */

export const getRemesas = async (mantisBusinessId, token, filters = {}) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/remesas`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
        mantisBusinessId,
        ...filters,
    }),
  });
    return res;
};

export const getRemesaById = async (mantisBusinessId, token, remesaId) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/remesas/${remesaId}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
        remesaId,
    }),
  });
    return res;
};

export const createRemesa = async (mantisBusinessId, mantisBusinessUserId, token, remesaData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/remesas/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
      body: JSON.stringify({
          mantisBusinessId,
          mantisBusinessUserId,
          ...remesaData,
      }),
  });
    return res;
};

export const updateRemesa = async (mantisBusinessId, token, remesaId, remesaData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/remesas/update`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
        mantisBusinessId,
        remesaId,
        ...remesaData,
    }),
  });
    return res;
};

export const deleteRemesa = async (mantisBusinessId, token, remesaId) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/remesas/delete`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
        mantisBusinessId,
        remesaId,
    }),
  });
    return res;
};

/**
 * ==================== PRE-MANIFESTOS ====================
 */

export const getPreManifiestos = async (mantisBusinessId, token, filters = {}) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/pre-manifiestos`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
        ...filters,
    }),
  });
    return res;
};

export const getPreManifiestoById = async (mantisBusinessId, token, preManifiestoId) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/pre-manifiestos/${preManifiestoId}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
        mantisBusinessId,
        preManifiestoId,
    }),
  });
    return res;
};

export const createPreManifiesto = async (mantisBusinessId, mantisBusinessUserId, token, preManifiestoData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/pre-manifiestos/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
        mantisBusinessId,
        mantisBusinessUserId,
        ...preManifiestoData,
    }),
  });
    return res;
};

export const updatePreManifiesto = async (mantisBusinessId, token, preManifiestoId, preManifiestoData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/pre-manifiestos/update`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
        mantisBusinessId,
        preManifiestoId,
        ...preManifiestoData,
    }),
  });
    return res;
};

export const deletePreManifiesto = async (mantisBusinessId, token, preManifiestoId) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/pre-manifiestos/delete`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            preManifiestoId,
        }),
    });
    return res;
};

export const getRemesasByPreManifiesto = async (mantisBusinessId, token, preManifiestoId) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/pre-manifiestos/${preManifiestoId}/remesas`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            preManifiestoId,
        }),
    });
    return res;
};

export const assignRemesasToPreManifiesto = async (mantisBusinessId, token, preManifiestoId, remesaIds) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/pre-manifiestos/assign-remesas`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
        preManifiestoId,
        remesaIds,
    }),
  });
    return res;
};

export const unlinkRemesasFromPreManifiesto = async (mantisBusinessId, token, preManifiestoId, remesaIds) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/pre-manifiestos/unlink-remesas`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            preManifiestoId,
            remesaIds,
        }),
    });
    return res;
};

export const confirmRemesasForCarga = async (mantisBusinessId, token, preManifiestoId, remesaIds) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/pre-manifiestos/confirm-remesas`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
      body: JSON.stringify({
          mantisBusinessId,
          preManifiestoId,
          remesaIds,
      }),
  });
    return res;
};

/**
 * ==================== MANIFESTOS ====================
 */

export const getManifiestos = async (mantisBusinessId, token, filters = {}) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/manifiestos`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
        mantisBusinessId,
        ...filters,
    }),
  });
    return res;
};

export const getManifiestoById = async (mantisBusinessId, token, manifiestoId) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/manifiestos/${manifiestoId}`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            manifiestoId,
        }),
    });
    return res;
};

export const getRemesasByManifiesto = async (mantisBusinessId, token, manifiestoId) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/manifiestos/${manifiestoId}/remesas`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            manifiestoId,
        }),
    });
    return res;
};

export const createManifiesto = async (mantisBusinessId, mantisBusinessUserId, token, manifiestoData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/manifiestos/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
        mantisBusinessId,
        mantisBusinessUserId,
        ...manifiestoData,
    }),
  });
    return res;
};

export const anularManifiesto = async (mantisBusinessId, mantisBusinessUserId, token, manifiestoId, motivo) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/manifiestos/anular`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
        mantisBusinessUserId,
        manifiestoId,
        motivo,
    }),
  });
    return res;
};

/**
 * ==================== ALERTAS ====================
 */

export const getAlertas = async (mantisBusinessId, token, filters = {}) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/alertas`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
        ...filters,
    }),
  });
    return res;
};

export const createAlerta = async (mantisBusinessId, token, alertaData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/alertas/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        mantisBusinessId,
        ...alertaData,
    }),
  });
    return res;
};

export const resolverAlerta = async (mantisBusinessId, mantisBusinessUserId, token, alertaId, comentario) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/alertas/resolver`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
        mantisBusinessId,
        mantisBusinessUserId,
        alertaId,
        comentario,
    }),
  });
    return res;
};

export const markAlertaVista = async (mantisBusinessId, mantisBusinessUserId, token, alertaId) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/alertas/marcar-vista`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
        mantisBusinessId,
        mantisBusinessUserId,
        alertaId,
    }),
  });
    return res;
};

/**
 * ==================== DASHBOARD ====================
 */

export const getDashboardStats = async (mantisBusinessId, token, fechaDesde, fechaHasta) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/dashboard/stats`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            fecha_desde: fechaDesde,
            fecha_hasta: fechaHasta,
        }),
    });
    return res;
};

/**
 * ==================== PDF GENERATION ====================
 */

export const downloadRemesaPDF = async (mantisBusinessId, token, remesaId) => {
    const response = await fetch(`${backUrl}/taktikFlows/roldan/remesas/${remesaId}/pdf`, withAuthCredentials({
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
        }),
    }));

    if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'Error downloading PDF' }));
        throw new Error(error.message || 'Error downloading PDF');
    }

    // Get the PDF blob
    const blob = await response.blob();
    
    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `remesa-${remesaId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true, message: 'PDF downloaded successfully' };
};

/**
 * Create orden de carga for a remesa (DB + Roldan integration).
 * Uses Firebird FACTURAS remesa; loggedInUserName/empacadoPor is used as EMPACADAPOR in Roldan.
 */
export const createOrdenCarga = async (mantisBusinessId, token, remesaId, mantisBusinessUserId = null, loggedInUserName = null) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/remesas/${remesaId}/orden-carga/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            mantisBusinessUserId,
            remesaId,
            loggedInUserName: loggedInUserName || null,
            empacadoPor: loggedInUserName || null,
        }),
    });
    return res;
};

export const downloadOrdenCargaPDF = async (mantisBusinessId, token, remesaId) => {
    const response = await fetch(`${backUrl}/taktikFlows/roldan/remesas/${remesaId}/orden-carga/pdf`, withAuthCredentials({
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            remesaId,
        }),
    }));

    if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'Error downloading PDF' }));
        throw new Error(error.message || 'Error downloading PDF');
    }

    // Get the PDF blob
    const blob = await response.blob();
    
    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `orden-carga-${remesaId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    return { success: true, message: 'PDF downloaded successfully' };
};

export const downloadManifiestoPDF = async (mantisBusinessId, token, manifiestoId) => {
    const response = await fetch(`${backUrl}/taktikFlows/roldan/manifiestos/${manifiestoId}/pdf`, withAuthCredentials({
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            manifiestoId,
        }),
    }));

    if (!response.ok) {
        const error = await response.json().catch(() => ({ message: 'Error downloading PDF' }));
        throw new Error(error.message || 'Error downloading PDF');
    }

    // Get the PDF blob
    const blob = await response.blob();
    
    // Create a download link
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `manifiesto-${manifiestoId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};

/**
 * ==================== WHATSAPP SHARING ====================
 */

export const shareRemesaWhatsApp = async (mantisBusinessId, token, remesaId, phoneNumber, whatsappAccount = null, hideInfo = false) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/remesas/share-whatsapp`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            remesaId,
            phoneNumber,
            whatsappAccount, // Optional, backend will fetch if not provided
            hideInfo, // Flag to hide monetary values in PDF
        }),
    });
    return res;
};

export const shareOrdenCargaWhatsApp = async (mantisBusinessId, token, remesaId, phoneNumber, whatsappAccount = null) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/remesas/${remesaId}/orden-carga/share-whatsapp`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            remesaId,
            phoneNumber,
            whatsappAccount,
        }),
    });
    return res;
};

export const shareManifiestoWhatsApp = async (
  mantisBusinessId,
  token,
  manifiestoId,
  phoneNumber,
  whatsappAccount = null
) => {
  const res = await fetchWrapper(
    `${backUrl}/taktikFlows/roldan/manifiestos/share-whatsapp`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        mantisBusinessId,
        manifiestoId,
        phoneNumber,
        whatsappAccount // Optional, backend will fetch if not provided
      })
    }
  );
  return res;
};

/**
 * ==================== ORDENCARGUE (SOAP) ====================
 */

export const getOrdencargue = async (mantisBusinessId, token, numeroOrden) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/ordencargue`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            numeroOrden,
        }),
    });
    return res;
};

export const createOrdencargue = async (mantisBusinessId, token, ordenCargueData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/ordencargue/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            ...ordenCargueData,
        }),
    });
    return res;
};

export const updateOrdencargue = async (mantisBusinessId, token, numeroOrden, ordenCargueData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/ordencargue/update`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            numeroOrden,
            ...ordenCargueData,
        }),
    });
    return res;
};

export const deleteOrdencargue = async (mantisBusinessId, token, numeroOrden) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/ordencargue/delete`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            numeroOrden,
        }),
    });
    return res;
};

/**
 * ==================== REMESAS (Firebird ERP) ====================
 */

export const getRemesaSOAP = async (mantisBusinessId, token, consecutivo) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/remesas`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            consecutivo,
        }),
    });
    return res;
};

export const createRemesaSOAP = async (mantisBusinessId, token, remesaData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/remesas/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            ...remesaData,
        }),
    });
    return res;
};

export const updateRemesaSOAP = async (mantisBusinessId, token, consecutivo, remesaData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/remesas/update`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            consecutivo,
            ...remesaData,
        }),
    });
    return res;
};

export const deleteRemesaSOAP = async (mantisBusinessId, token, consecutivo) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/remesas/delete`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            consecutivo,
        }),
    });
    return res;
};

/**
 * ==================== MANIFESTOS (Firebird ERP - Despachos) ====================
 */

export const getManifiestoSOAP = async (mantisBusinessId, token, numeroDespacho) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/manifiestos`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            numeroDespacho,
        }),
    });
    return res;
};

export const createManifiestoSOAP = async (mantisBusinessId, token, despachoData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/manifiestos/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            ...despachoData,
        }),
    });
    return res;
};

export const updateManifiestoSOAP = async (mantisBusinessId, token, numeroDespacho, despachoData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/manifiestos/update`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            numeroDespacho,
            ...despachoData,
        }),
    });
    return res;
};

export const deleteManifiestoSOAP = async (mantisBusinessId, token, numeroDespacho) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/manifiestos/delete`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            numeroDespacho,
        }),
    });
    return res;
};

/**
 * ==================== VEHICULOS (Firebird ERP) ====================
 */

export const getVehiculoSOAP = async (mantisBusinessId, token, placa) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/vehiculos`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            placa,
        }),
    });
    return res;
};

export const createVehiculoSOAP = async (mantisBusinessId, token, vehiculoData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/vehiculos/create`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            ...vehiculoData,
        }),
    });
    return res;
};

export const updateVehiculoSOAP = async (mantisBusinessId, token, placa, vehiculoData) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/vehiculos/update`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            placa,
            ...vehiculoData,
        }),
    });
    return res;
};

/**
 * ==================== FIREBIRD DATABASE (CIUDADES) ====================
 */

export const searchCiudades = async (mantisBusinessId, token, searchTerm) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/ciudades/search`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            searchTerm,
        }),
    });
    return res;
};

export const searchTerceros = async (mantisBusinessId, token, searchTerm) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/firebird/terceros/search`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            searchTerm,
        }),
    });
    return res;
};

export const createManifiestoWithRNDC = async (mantisBusinessId, mantisBusinessUserId, token, payload) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/manifiestos/create-with-rndc`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            mantisBusinessUserId,
            ...payload,
        }),
    });
    return res;
};

/**
 * Validate flete against RNDC minimum for the route (origen_id, destino_id).
 * Returns { success, warning, message?, minimum_value_trip? }. If warning is true, frontend should alert but still allow user to proceed.
 */
export const validateRndcTarifa = async (mantisBusinessId, token, { origen_id, destino_id, flete }) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/manifiestos/validate-rndc-tarifa`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            origen_id: origen_id != null ? String(origen_id) : "",
            destino_id: destino_id != null ? String(destino_id) : "",
            flete: flete != null ? flete : "",
        }),
    });
    return res;
};

export const createManifiestoWithRNDCStart = async (mantisBusinessId, mantisBusinessUserId, token, payload) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/manifiestos/create-with-rndc/start`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            mantisBusinessUserId,
            ...payload,
        }),
    });
    return res;
};

export const createManifiestoWithRNDCStep = async (mantisBusinessId, token, jobId, stepIndex) => {
    const res = await fetchWrapper(`${backUrl}/taktikFlows/roldan/manifiestos/create-with-rndc/step`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
            mantisBusinessId,
            jobId,
            stepIndex,
        }),
    });
    return res;
};

